<template>
  <footer class="footer-area footer-notin-premium" :style="footerRightStyle">
    <div class="footer-wrapper" v-if="NOTARIA && NOTARIA.Theme">
      <v-container>
        <v-row class="footer-top-row py-12">
          <!-- Col 1: Schedule -->
          <v-col lg="3" md="6" sm="12" cols="12" class="mb-8 mb-lg-0">
            <div class="footer-widget-premium">
              <h4 :style="tituloHorarioStyle" class="widget-title mb-6">
                <v-icon v-if="NOTARIA.Theme.Footer.MostrarIconos !== false" class="mr-2" :color="NOTARIA.Theme.Footer.TituloHorario.css.Color">mdi-clock-outline</v-icon>
                {{ NOTARIA.Theme.Footer.TituloHorario.Texto }}
              </h4>
              <div :style="horarioStyle" class="horario-content" v-html="NOTARIA.Contacto.Horario.replace(/(?:\r\n|\r|\n)/g, '<br>')">
              </div>
            </div>
          </v-col>

          <!-- Col 2: Contact -->
          <v-col lg="4" md="6" sm="12" cols="12" class="mb-8 mb-lg-0">
            <div class="footer-widget-premium" :style="contactoStyle">
              <h4 :style="tituloContactoStyle" class="widget-title mb-6">
                <v-icon v-if="NOTARIA.Theme.Footer.MostrarIconos !== false" class="mr-2" :color="NOTARIA.Theme.Footer.TituloDContacto.css.Color">mdi-information-outline</v-icon>
                {{ NOTARIA.Theme.Footer.TituloDContacto.Texto }}
              </h4>
              <ul class="contact-list pl-0 liststyle">
                <li v-if="NOTARIA.Contacto.Telefono || NOTARIA.Contacto.Movil" class="mb-4">
                  <v-icon v-if="NOTARIA.Theme.Footer.MostrarIconos !== false" class="mr-2" small :color="NOTARIA.Theme.Footer.ContactoCSS.Color">mdi-phone</v-icon>
                  <a v-if="NOTARIA.Contacto.Telefono" :style="contactoLinkStyle" :href="'tel:' + NOTARIA.Contacto.Telefono">
                    {{ NOTARIA.Contacto.Telefono }}
                  </a>
                  <span v-if="NOTARIA.Contacto.Telefono && NOTARIA.Contacto.Movil" :style="contactoLinkStyle"> | </span>
                  <a v-if="NOTARIA.Contacto.Movil" :style="contactoLinkStyle" :href="'tel:' + NOTARIA.Contacto.Movil">
                    {{ NOTARIA.Contacto.Movil }}
                  </a>
                </li>
                <li class="mb-4">
                  <v-icon v-if="NOTARIA.Theme.Footer.MostrarIconos !== false" class="mr-2" small :color="NOTARIA.Theme.Footer.ContactoCSS.Color">mdi-map-marker</v-icon>
                  <a :style="contactoLinkStyle" :href="NOTARIA.Contacto.EnlaceMaps" target="_blank">
                    {{ NOTARIA.Contacto.Direccion }}, {{ NOTARIA.Contacto.CP }} {{ NOTARIA.Contacto.Municipio }}, {{ NOTARIA.Contacto.Provincia }}
                  </a>
                </li>
                <li v-if="NOTARIA.Contacto.Email || NOTARIA.Contacto.Email2" class="mb-4">
                  <v-icon v-if="NOTARIA.Theme.Footer.MostrarIconos !== false" class="mr-2" small :color="NOTARIA.Theme.Footer.ContactoCSS.Color">mdi-email</v-icon>
                  <a v-if="NOTARIA.Contacto.Email" :style="contactoLinkStyle" :href="'mailto:' + NOTARIA.Contacto.Email">
                    {{ NOTARIA.Contacto.Email }}
                  </a>
                  <span v-if="NOTARIA.Contacto.Email && NOTARIA.Contacto.Email2" :style="contactoLinkStyle"> | </span>
                  <a v-if="NOTARIA.Contacto.Email2" :style="contactoLinkStyle" :href="'mailto:' + NOTARIA.Contacto.Email2">
                    {{ NOTARIA.Contacto.Email2 }}
                  </a>
                </li>
                <li v-if="accesoSolicitud.visible('pie')" class="mb-4">
                  <v-icon v-if="NOTARIA.Theme.Footer.MostrarIconos !== false" class="mr-2" small :color="NOTARIA.Theme.Footer.ContactoCSS.Color">mdi-file-document-edit-outline</v-icon>
                  <NuxtLink :style="contactoLinkStyle" :to="accesoSolicitud.enlace('pie')">{{ tSolicitud('Encargo online') }}</NuxtLink>
                </li>
              </ul>
              
              <!-- Social links -->
              <div class="social-share-premium mt-6" :style="{ textAlign: NOTARIA.Theme.Footer.ContactoCSS.Align }">
                <ul class="social-share liststyle" style="display: inline-flex; gap: 16px;">
                  <li v-if="NOTARIA.Contacto.Facebook">
                    <a :style="contactoLinkStyle" :href="NOTARIA.Contacto.Facebook" target="_blank" :aria-label="'Facebook de ' + NOTARIA.Nombre">
                      <v-icon :color="NOTARIA.Theme.Footer.ContactoCSS.Color">mdi-facebook</v-icon>
                    </a>
                  </li>
                  <li v-if="NOTARIA.Contacto.LinkedIn">
                    <a :style="contactoLinkStyle" :href="NOTARIA.Contacto.LinkedIn" target="_blank" :aria-label="'LinkedIn de ' + NOTARIA.Nombre">
                      <v-icon :color="NOTARIA.Theme.Footer.ContactoCSS.Color">mdi-linkedin</v-icon>
                    </a>
                  </li>
                  <li v-if="NOTARIA.Contacto.Twitter">
                    <a :style="contactoLinkStyle" :href="NOTARIA.Contacto.Twitter" target="_blank" :aria-label="'Twitter de ' + NOTARIA.Nombre">
                      <v-icon :color="NOTARIA.Theme.Footer.ContactoCSS.Color">mdi-twitter</v-icon>
                    </a>
                  </li>
                  <li v-if="NOTARIA.Contacto.Instagram">
                    <a :style="contactoLinkStyle" :href="NOTARIA.Contacto.Instagram" target="_blank" :aria-label="'Instagram de ' + NOTARIA.Nombre">
                      <v-icon :color="NOTARIA.Theme.Footer.ContactoCSS.Color">mdi-instagram</v-icon>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </v-col>

          <!-- Col 3: Map -->
          <v-col lg="5" md="12" sm="12" cols="12" v-if="NOTARIA.Theme.Footer.MostrarMapa">
            <div class="footer-map-container elevation-6">
              <GoogleMap ref="mymap" api-key="AIzaSyCRbdQmLDJQz-JO8j3g_2J9yEOd27nJmvw"
                :center="{lat: NOTARIA.Contacto.Coordinates.lat, lng: NOTARIA.Contacto.Coordinates.lng }" :zoom="15"
                map-type-id="roadmap" class="map-responsive-premium" :options="gmapOptions">
                <Marker :options="{position:{lat: NOTARIA.Contacto.Coordinates.lat, lng: NOTARIA.Contacto.Coordinates.lng },label:NOTARIA.Theme.Footer.PunteroMapa, title:NOTARIA.Nombre, clickable:true, draggable:false}"
                  @click="openWindow">
                  <InfoWindow @closeclick="window_open = false" :opened="window_open"
                    :options="{position:{lat: NOTARIA.Contacto.Coordinates.lat, lng: NOTARIA.Contacto.Coordinates.lng},pixelOffset: { width: 0, height: -35 }}">
                    <div style="color: #333 !important; padding: 10px;">
                      <b style="font-size: 1.1rem;">{{ NOTARIA.Nombre }}</b><br><br>
                      {{ NOTARIA.Contacto.Direccion }}<br>
                      {{ NOTARIA.Contacto.CP }} {{ NOTARIA.Contacto.Municipio }}<br><br>
                      <a :href="NOTARIA.Contacto.EnlaceMaps" target="_blank" style="color: #1976D2 !important; font-weight: bold;">Abrir en Google Maps</a>
                    </div>
                  </InfoWindow>
                </Marker>
              </GoogleMap>
            </div>
          </v-col>
        </v-row>

        <!-- Divider -->
        <v-divider class="footer-divider" :style="{ opacity: 0.1, backgroundColor: NOTARIA.Theme.Footer.ContactoCSS.Color }"></v-divider>

        <!-- Bottom Bar: Legal & Copyright -->
        <div class="footer-bottom-bar py-6 d-flex flex-column flex-md-row justify-space-between align-center flex-wrap" style="gap: 20px;">
          <div class="text-center text-md-left mb-4 mb-md-0">
            <p class="mb-0" :style="copyrightStyle">
              Copyright © {{ new Date().getFullYear() }} <a href="https://unidata.es" :style="copyrightStyle">UNIDATA</a>. Todos los derechos reservados.
            </p>
          </div>
          <div class="legal-links">
            <a :style="copyrightStyle" href="/avisolegal" class="mr-3">{{ $t('avisoLegal') }}</a>
            <a :style="copyrightStyle" href="/politicacookies" class="mr-3">{{ $t('politicaCookies') }}</a>
            <a :style="copyrightStyle" href="/protecciondatos" class="mr-3">{{ $t('proteccionDatos') }}</a>
            <a :style="copyrightStyle" href="/accesibilidad" class="mr-3">{{ $t('accesibilidad') }}</a>
            <a v-if="NOTARIA.Theme.Menu.ShowNV && NOTARIA.NotariaVirtual" :style="copyrightStyle" :href="NOTARIA.NotariaVirtualFrame ? getLocalePath('/NotariaVirtual'): formatUrl(NOTARIA.NotariaVirtual)" target="_blank" class="mr-3">{{ getTitleNV() }}</a>
            <a v-if="NOTARIA.UrlDenuncias && NOTARIA.UrlDenuncias != ''" :style="copyrightStyle" :href="getURLDenuncias()" class="mr-3">{{ $t('denuncias') }}</a>
            <a :style="copyrightStyle" href="https://controlpanel.unidata.es/" target="_blank">Panel de Control</a>
          </div>
        </div>

        <!-- SubFooter Row -->
        <v-row v-if="NOTARIA.Theme.Footer.MostrarSubFooter">
          <v-col cols="12" class="pa-0">
            <FooterSubFooter />
          </v-col>
        </v-row>
      </v-container>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { GoogleMap, Marker, InfoWindow } from 'vue3-google-map'
import { useStore } from '../../store/index'
const store = useStore()
const {NOTARIA} = storeToRefs(store)

import { useUtils } from '#imports';
const {imagenIDtoSRC,$t, getLocalePath}=useUtils()
import { useAccesoSolicitud } from '../../composables/solicitudAcceso'
import { t as tSolicitud } from '../../composables/solicitudTextos'
const accesoSolicitud = useAccesoSolicitud()

const window_open = ref(false)
const gmapOptions = ref({
    zoomControl: false,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: false,
    disableDefaultUi: false,
  })

function getURLDenuncias()
{
  if(NOTARIA.value && NOTARIA.value.UrlDenuncias)
  {
    if(NOTARIA.value.UrlDenuncias.startsWith("https"))
    {
      return NOTARIA.value.UrlDenuncias 
    }else{
       return "https://"+ NOTARIA.value.UrlDenuncias 
    }
  }
}

function getTitleNV()
{
  if(!NOTARIA.value?.Theme?.Menu?.NameWeb)
  {
    return $t('NotariaVirtual') 
  } else {
    const nameWeb = NOTARIA.value.Theme.Menu.NameWeb.toUpperCase();
    if(nameWeb === "NOTARÍA VIRTUAL" || nameWeb === "NOTARIA VIRTUAL" || nameWeb === "NOTARIAVIRTUAL")
    {
      return $t('NotariaVirtual') 
    } else {
      return NOTARIA.value.Theme.Menu.NameWeb
    }
  }
}

function formatUrl(url: string) {
  if (!url) return '';
  if (!/^https?:\/\//i.test(url)) return 'http://' + url;
  return url;
}

function openWindow() {
  window_open.value = true
}
const horarioStyle = computed(() => ({
    display: 'block',
  color: NOTARIA.value?.Theme?.Footer?.HorarioCSS?.Color ?? '',
  textShadow: NOTARIA.value?.Theme?.Footer?.HorarioCSS?.BackgroundColor ? `4px 2px 6px ${NOTARIA.value.Theme.Footer.HorarioCSS.BackgroundColor}` : '',
  fontFamily: NOTARIA.value?.Theme?.Footer?.HorarioCSS?.Font ?? '',
  fontSize: NOTARIA.value?.Theme?.Footer?.HorarioCSS?.Size ? NOTARIA.value.Theme.Footer.HorarioCSS.Size : '',
  fontWeight: NOTARIA.value?.Theme?.Footer?.HorarioCSS?.Weight ?? '',
  textAlign: NOTARIA.value?.Theme?.Footer?.HorarioCSS?.Align ?? ''
}))

const tituloHorarioStyle = computed(() => ({
  display: 'block',
  color: NOTARIA.value?.Theme?.Footer?.TituloHorario?.css?.Color ?? '',
  textShadow: NOTARIA.value?.Theme?.Footer?.TituloHorario?.css?.BackgroundColor ? `4px 2px 6px ${NOTARIA.value.Theme.Footer.TituloHorario.css.BackgroundColor}` : '',
  fontFamily: NOTARIA.value?.Theme?.Footer?.TituloHorario?.css?.Font ?? '',
  fontWeight: NOTARIA.value?.Theme?.Footer?.TituloHorario?.css?.Weight ?? '',
  textAlign: NOTARIA.value?.Theme?.Footer?.TituloHorario?.css?.Align ?? '',
  fontSize: NOTARIA.value?.Theme?.Footer?.TituloHorario?.css?.Size ? NOTARIA.value.Theme.Footer.TituloHorario.css.Size : '',
}))

const contactoStyle = computed(() => ({
  display: 'block',
  color: NOTARIA.value?.Theme?.Footer?.ContactoCSS?.Color ?? '',
  textShadow: NOTARIA.value?.Theme?.Footer?.ContactoCSS?.BackgroundColor ? `4px 2px 6px ${NOTARIA.value.Theme.Footer.ContactoCSS.BackgroundColor}` : '',
  fontFamily: NOTARIA.value?.Theme?.Footer?.ContactoCSS?.Font ?? '',
  fontSize: NOTARIA.value?.Theme?.Footer?.ContactoCSS?.Size ?? '',
  fontWeight: NOTARIA.value?.Theme?.Footer?.ContactoCSS?.Weight ?? '',
  textAlign: NOTARIA.value?.Theme?.Footer?.ContactoCSS?.Align ?? ''
}))

const tituloContactoStyle = computed(() => ({
  display: 'block',
  color: NOTARIA.value?.Theme?.Footer?.TituloDContacto?.css?.Color ?? '',
  textShadow: NOTARIA.value?.Theme?.Footer?.TituloDContacto?.css?.BackgroundColor ? `4px 2px 6px ${NOTARIA.value.Theme.Footer.TituloDContacto.css.BackgroundColor}`: '',
  fontFamily: NOTARIA.value?.Theme?.Footer?.TituloDContacto?.css?.Font ?? '',
  fontWeight: NOTARIA.value?.Theme?.Footer?.TituloDContacto?.css?.Weight ?? '',
  fontSize: NOTARIA.value?.Theme?.Footer?.TituloDContacto?.css?.Size ?? '',
  textAlign: NOTARIA.value?.Theme?.Footer?.TituloDContacto?.css?.Align ?? ''
}))

const footerRightStyle = computed(() => ({
  background:
    NOTARIA.value?.Theme?.Footer?.FooterCSS ? 
      `linear-gradient(145deg,${NOTARIA.value.Theme.Footer.FooterCSS.BackgroundColor} 0%, ${NOTARIA.value.Theme.Footer.FooterCSS.BackgroundColorGradient} 100%)`
      : ''
}))

const copyrightStyle = computed(() => ({
  color: NOTARIA.value?.Theme?.Footer?.ContactoCSS?.Color ?? '',
  fontFamily: NOTARIA.value?.Theme?.Footer?.ContactoCSS?.Font ?? '',
  fontSize: NOTARIA.value?.Theme?.Footer?.ContactoCSS?.Size ?? '',
  fontWeight: NOTARIA.value?.Theme?.Footer?.ContactoCSS?.Weight ?? ''
}))
const contactoLinkStyle = computed(() => ({
  color: NOTARIA.value?.Theme?.Footer?.ContactoCSS?.Color ?? '',
  fontFamily: NOTARIA.value?.Theme?.Footer?.ContactoCSS?.Font ?? '',
  fontSize: NOTARIA.value?.Theme?.Footer?.ContactoCSS?.Size ?? '',
  fontWeight: NOTARIA.value?.Theme?.Footer?.ContactoCSS?.Weight ?? '',
  textDecoration: 'none'
}))
</script>
